/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListDocumentExecutionGroupsSortCriteria {
    getFixupPrototypeFunction() { return AwsSsmListDocumentExecutionGroupsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListDocumentExecutionGroupsSortCriteria>): AwsSsmListDocumentExecutionGroupsSortCriteria {
        let obj = Object.assign(new AwsSsmListDocumentExecutionGroupsSortCriteria(), model);
        AwsSsmListDocumentExecutionGroupsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListDocumentExecutionGroupsSortCriteria>): AwsSsmListDocumentExecutionGroupsSortCriteria {
        if (!model) return null;
        return AwsSsmListDocumentExecutionGroupsSortCriteria.newInstance(<AwsSsmListDocumentExecutionGroupsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListDocumentExecutionGroupsSortCriteria) {
        if (!obj) return;

        models.AwsSsmListDocumentExecutionGroupsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListDocumentExecutionGroupsSortCriteria): boolean {
        Object.setPrototypeOf(obj, AwsSsmListDocumentExecutionGroupsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AwsSsmListDocumentExecutionGroupsSortColumn;

    ascending: boolean;

}
